import React from 'react';
import QuizView from "./components/quizView";



function App() {
  return (
    <div className="App">
      <QuizView/>
    </div>
  );
}

export default App;
